/**
 * Update this list when adding/removing features
 */
export const FEATURE_KEYS = {
  PLAYLIST_ITEM_DURATION: "playlist_item_duration",
  PLAYLIST_ITEM_START_END: "playlist_item_start_end",
} as const;

export type FeatureKey = (typeof FEATURE_KEYS)[keyof typeof FEATURE_KEYS];
